import { AxiosError } from 'axios';

export type DeleteCircuitErrorCode =
  | 'CIRCUIT_SHARED_DELETE_FORBIDDEN'
  | 'CIRCUIT_LINKED_TO_ESTIMATES_DELETE_FORBIDDEN';

export const parseDeleteCircuitErrorCode = (
  error: unknown,
): DeleteCircuitErrorCode | null => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as { code?: string } | undefined;
    if (
      data?.code === 'CIRCUIT_SHARED_DELETE_FORBIDDEN' ||
      data?.code === 'CIRCUIT_LINKED_TO_ESTIMATES_DELETE_FORBIDDEN'
    ) {
      return data.code;
    }
  }
  return null;
};
